import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { setSearchState } from '../actions/setSearchState';

/**
 * Sets whether the user is searching or not.
 */
export let setSearchStateMutator = mutator(setSearchState, search => {
    getStore().isInSearchMode = search.isInSearchMode;
});
